import jwtDecode from "jwt-decode";
import { AuthAPI } from "../api";
import {
  setAuthDetails,
  setAuthToken,
  clearAuthDetails,
  clearGameState,
} from "../../redux/dispatchers";
import { history } from "../../index";
import { store } from "../../redux/store";
import { showModal } from "../../redux/dispatchers";

export const loginUser = async (params) => {
  try {
    const authDetails = await AuthAPI.login(params);
    // save auth details to redux store
    const { accessToken, refreshToken, displayName, id, role } = authDetails;

    setAuthDetails(accessToken, refreshToken, displayName, id, role);

    history.push("/");

    return authDetails;
  } catch (e) {
    // error message
    const { message } = e.response.data;

    return message;
  }
};

export const registerUser = async (params) => {
  try {
    await AuthAPI.register(params);
  } catch (e) {
    // error message
    const { message } = e.response.data;
    return message;
  }
};

export const checkAuth = async () => {
  const { accessToken } = store.getState().authDetails;

  if (!accessToken) {
    return false;
  }

  const { exp } = jwtDecode(accessToken);

  // if the access token expired, call refresh api ot get a new token
  if (new Date() >= exp) {
    try {
      const result = await AuthAPI.refresh();
      const { accessToken } = result;
      // replace the accesstoken stored in redux store
      setAuthToken(accessToken);

      return true;
    } catch (e) {
      // falls into here when the refresh token expired
      return false;
    }
  }

  return true;
};

export const logoutUser = async () => {
  await AuthAPI.logout();

  // clear redux store
  clearAuthDetails();
  clearGameState();

  // navigate user to login page
  history.push("/login");
};

export const fetchResetPasswordLink = async (email) => {
  try {
    const result = await AuthAPI.getResetPasswordLink({
      email,
    });

    showModal("Reset Your Password", result.message, null, "Close");
  } catch (e) {
    if (e.response) {
      showModal("Failed to Send Email", e.response.data.message, null, "Close");
    }
  }
};

export const userResetPassword = async (token, password) => {
  try {
    await AuthAPI.resetPassword(token, {
      password,
    });

    showModal(
      "Successfully Reset Password",
      "You have successfully reset your password, redirecting back to login page.",
      null,
      "Close"
    );
    history.push("/login");
  } catch (e) {
    const { message } = e.response.data;

    showModal("Fail to Reset Password", message, null, "Close");
  }
};

export const verifyUserAccount = async (token) => {
  try {
    const result = await AuthAPI.verifyAccount(token);

    return result;
  } catch {
    return null;
  }
};
